module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "pagamentos-lista"
  }, [(_vm.pagamentos.length < 1) ? _c('v-card', {
    staticClass: "text-xs-center pt-5 pb-5 px-4 empty-state-card",
    attrs: {
      "flat": ""
    }
  }, [_c('v-icon', {
    attrs: {
      "size": "42",
      "color": "grey lighten-1"
    }
  }, [_vm._v("account_balance_wallet")]), _vm._v(" "), _c('div', {
    staticClass: "subheading grey--text text--darken-1 mt-3"
  }, [_vm._v("Nenhum pagamento registrado para este imóvel.")]), _vm._v(" "), _c('div', {
    staticClass: "caption grey--text mt-1"
  }, [_vm._v("Solicite o primeiro pagamento para iniciar o histórico.")]), _vm._v(" "), (_vm.$hasGranularPermission('pagamentos', 'add')) ? _c('div', {
    staticClass: "mt-4"
  }, [_c('v-btn', {
    staticClass: "secondary secondary--text mx-0",
    attrs: {
      "outline": "",
      "large": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.openDialogAdicionar($event)
      }
    }
  }, [_vm._v("Solicitar Pagamento")])], 1) : _vm._e()], 1) : [_c('v-card', {
    staticClass: "mb-3 resumo-card",
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-text', {
    staticClass: "py-3 px-4"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    staticClass: "resumo-coluna",
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('div', {
    staticClass: "caption grey--text text--darken-1"
  }, [_vm._v("Solicitações")]), _vm._v(" "), _c('div', {
    staticClass: "subheading"
  }, [_c('strong', [_vm._v(_vm._s(_vm.pagamentos.length))])])]), _vm._v(" "), _c('v-flex', {
    staticClass: "resumo-coluna",
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('div', {
    staticClass: "caption grey--text text--darken-1"
  }, [_vm._v("Total solicitado")]), _vm._v(" "), _c('div', {
    staticClass: "subheading secondary--text"
  }, [_c('strong', [_vm._v(_vm._s(_vm.formatCurrency(_vm.totalSolicitado)))])])]), _vm._v(" "), _c('v-flex', {
    staticClass: "resumo-coluna",
    attrs: {
      "xs12": "",
      "sm4": ""
    }
  }, [_c('div', {
    staticClass: "caption grey--text text--darken-1"
  }, [_vm._v("Total pago")]), _vm._v(" "), _c('div', {
    staticClass: "subheading verde--text"
  }, [_c('strong', [_vm._v(_vm._s(_vm.formatCurrency(_vm.totalPago)))])])])], 1)], 1)], 1), _vm._v(" "), _vm._l((_vm.pagamentos), function(item, index) {
    return _c('v-card', {
      key: item.id,
      staticClass: "mb-2 pagamento-card",
      class: ("status-" + (item.status)),
      attrs: {
        "flat": ""
      }
    }, [_c('v-card-text', {
      staticClass: "py-4 px-4 lista_pagamentos"
    }, [_c('v-layout', {
      attrs: {
        "row": "",
        "wrap": "",
        "align-center": ""
      }
    }, [_c('v-flex', {
      staticClass: "mb-3 mb-sm-0 dados-coluna",
      attrs: {
        "xs12": "",
        "sm6": "",
        "md7": ""
      }
    }, [_c('div', {
      staticClass: "subheading pagamento-titulo"
    }, [_c('span', {
      staticClass: "status_circulo",
      style: ({
        'background-color': _vm.getStatusColor(item.status)
      })
    }), _vm._v(" "), _c('strong', [_vm._v(_vm._s(item.descricao))])]), _vm._v(" "), _c('div', {
      staticClass: "mt-2"
    }, [_c('span', {
      staticClass: "status_tag",
      style: ({
        'background-color': _vm.getStatusColor(item.status)
      })
    }, [_vm._v("\n                " + _vm._s(_vm.formatStatus(item.status)) + "\n              ")]), _vm._v(" "), (item.status === 'rejeitado' && item.observacao) ? _c('span', {
      staticClass: "caption grey--text text--darken-1 ml-2"
    }, [_vm._v("\n                " + _vm._s(item.observacao) + "\n              ")]) : _vm._e()]), _vm._v(" "), _c('v-layout', {
      staticClass: "mt-2",
      attrs: {
        "row": "",
        "wrap": ""
      }
    }, [_c('v-flex', {
      staticClass: "caption grey--text text--darken-1 meta-item",
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('strong', [_vm._v("Solicitado por:")]), _vm._v(" " + _vm._s(item.solicitante ? item.solicitante.name : '---') + "\n              ")]), _vm._v(" "), _c('v-flex', {
      staticClass: "caption grey--text text--darken-1 meta-item",
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('strong', [_vm._v("Aprovador:")]), _vm._v(" " + _vm._s(item.aprovador ? item.aprovador.name : '---') + "\n              ")]), _vm._v(" "), _c('v-flex', {
      staticClass: "caption grey--text text--darken-1 meta-item",
      attrs: {
        "xs12": "",
        "md6": ""
      }
    }, [_c('strong', [_vm._v("Vencimento:")]), _vm._v(" " + _vm._s(_vm.formatDate(item.data_vencimento)) + "\n              ")]), _vm._v(" "), (item.data_pagamento) ? _c('v-flex', {
      staticClass: "caption verde--text text--darken-2 meta-item",
      attrs: {
        "xs12": ""
      }
    }, [_c('strong', [_vm._v("Pago em:")]), _vm._v(" " + _vm._s(_vm.formatDate(item.data_pagamento)) + "\n              ")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('v-flex', {
      staticClass: "mb-3 mb-sm-0 valor-coluna",
      attrs: {
        "xs12": "",
        "sm4": "",
        "md3": ""
      }
    }, [_c('div', {
      staticClass: "caption grey--text text--darken-1"
    }, [_c('strong', [_vm._v("Valor")])]), _vm._v(" "), _c('div', {
      staticClass: "headline secondary--text valor-principal"
    }, [_vm._v(_vm._s(_vm.formatCurrency(item.valor)))])]), _vm._v(" "), _c('v-flex', {
      staticClass: "acoes-coluna",
      attrs: {
        "xs12": "",
        "sm2": "",
        "md2": ""
      }
    }, [_c('v-layout', {
      staticClass: "acoes-layout",
      attrs: {
        "row": "",
        "align-center": ""
      }
    }, [(item.documento_url) ? _c('v-btn', {
      staticClass: "mr-1",
      attrs: {
        "icon": "",
        "outline": "",
        "color": "grey",
        "href": item.documento_url,
        "target": "_blank",
        "title": "Boleto"
      }
    }, [_c('v-icon', {
      attrs: {
        "size": "19"
      }
    }, [_vm._v("description")])], 1) : _vm._e(), _vm._v(" "), (item.comprovante_url) ? _c('v-btn', {
      staticClass: "mr-1",
      attrs: {
        "icon": "",
        "outline": "",
        "color": "grey",
        "href": item.comprovante_url,
        "target": "_blank",
        "title": "Comprovante"
      }
    }, [_c('v-icon', {
      attrs: {
        "size": "19"
      }
    }, [_vm._v("receipt")])], 1) : _vm._e(), _vm._v(" "), (_vm.hasMenuActions(item)) ? _c('v-menu', {
      attrs: {
        "bottom": "",
        "left": "",
        "offset-y": ""
      }
    }, [_c('v-btn', {
      staticClass: "botao_lapis secondary ma-0",
      attrs: {
        "slot": "activator",
        "dark": "",
        "fab": ""
      },
      slot: "activator"
    }, [_c('v-icon', [_vm._v("more_vert")])], 1), _vm._v(" "), _c('v-list', {
      attrs: {
        "dense": ""
      }
    }, [(item.status === 'pendente' && _vm.canApproveAction(item)) ? _c('v-list-tile', {
      on: {
        "click": function($event) {
          _vm.openDialogAprovar(item)
        }
      }
    }, [_c('v-list-tile-action', [_c('v-icon', {
      attrs: {
        "color": "blue"
      }
    }, [_vm._v("check_circle")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Avaliar")])], 1) : _vm._e(), _vm._v(" "), (_vm.canRegisterPaymentAction(item)) ? _c('v-list-tile', {
      on: {
        "click": function($event) {
          _vm.openDialogPagar(item)
        }
      }
    }, [_c('v-list-tile-action', [_c('v-icon', {
      attrs: {
        "color": "green"
      }
    }, [_vm._v("payment")])], 1), _vm._v(" "), _c('v-list-tile-title', [_vm._v("Registrar Pagamento")])], 1) : _vm._e(), _vm._v(" "), (_vm.canDeleteAction(item)) ? _c('v-list-tile', {
      on: {
        "click": function($event) {
          _vm.excluirPagamento(item)
        }
      }
    }, [_c('v-list-tile-action', [_c('v-icon', {
      attrs: {
        "color": "red"
      }
    }, [_vm._v("delete")])], 1), _vm._v(" "), _c('v-list-tile-title', {
      staticClass: "red--text font-weight-bold"
    }, [_vm._v("Apagar")])], 1) : _vm._e()], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), (index + 1 < _vm.pagamentos.length) ? _c('v-divider') : _vm._e()], 1)
  }), _vm._v(" "), (_vm.$hasGranularPermission('pagamentos', 'add')) ? _c('div', {
    staticClass: "text-xs-center mt-4 mb-4"
  }, [_c('v-btn', {
    staticClass: "secondary secondary--text",
    attrs: {
      "outline": "",
      "large": ""
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.openDialogAdicionar($event)
      }
    }
  }, [_vm._v("Solicitar Novo Pagamento")])], 1) : _vm._e()], _vm._v(" "), _c('PagamentosAdicionar', {
    attrs: {
      "visible": _vm.dialogAdicionar,
      "imovelId": _vm.imovelId
    },
    on: {
      "close": function($event) {
        _vm.dialogAdicionar = false
      },
      "saved": _vm.loadPagamentos
    }
  }), _vm._v(" "), _c('PagamentosAprovar', {
    attrs: {
      "visible": _vm.dialogAprovar,
      "pagamento": _vm.selectedPagamento
    },
    on: {
      "close": function($event) {
        _vm.dialogAprovar = false
      },
      "saved": _vm.loadPagamentos
    }
  }), _vm._v(" "), _c('PagamentosPagar', {
    attrs: {
      "visible": _vm.dialogPagar,
      "pagamento": _vm.selectedPagamento
    },
    on: {
      "close": function($event) {
        _vm.dialogPagar = false
      },
      "saved": _vm.loadPagamentos
    }
  })], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fe406a08"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Imoveis/Pagamentos/PagamentosLista.vue
// module id = 1046
// module chunks = 1